import { Injectable } from '@angular/core';
import { GetDistanceToTargetsRequest } from 'emr-ng-shared';

@Injectable()
export abstract class ShowDistancePopup {
    abstract OpenShowDistancePopup(distanceToTargetsRequest: GetDistanceToTargetsRequest): void;
}

